import { connect } from "react-redux";
import { CourseInDto } from "../../../../../../../../types/course.dto";
import { Title, SubTitle, Text } from "./styles";
import Link from "../../../../../../../../components/Link";
import Button from "../../../../../../../../components/Button";
import Icon from "../../../../../../../../components/Icon";
import { Center } from "../../../../../../../../components/StyledComponents";
import ArrowRight from "../../../../../../../../assets/icons/icon-cool/outline/Arrows-chevron/Right.svg";

interface ComponentProps {
  newAnswersQuiz;
}

const Component = ({ newAnswersQuiz }: ComponentProps) => {
  return (
    <>
      <SubTitle>No has logrado superar el test.</SubTitle>

      <Title>Tu puntuación: {newAnswersQuiz?.score}%</Title>
      <div style={{ height: 95 }} />
      <Title>
        ¡No te preocupes! 🙂
        <br /> La próxima vez lo harás mejor.
      </Title>
      <div style={{ height: 25 }} />
      <Text>
        Te recomendamos repasar el material y practicar más para alcanzar tus
        objetivos.
      </Text>
      <div style={{ height: 25 }} />
      <Center horizontal="center" vertical="center">
        <Link
          options={{ skin: "gray", size: "md", type: "outline" }}
          style={{ gap: 8 }}
          href="/dashboard/mis-cursos/list"
        >
          Ir a mis cursos
          <Icon icon={ArrowRight} size="16px" color={"black"} />
        </Link>
      </Center>
      <div style={{ height: 25 }} />
      <Center horizontal="center" vertical="center">
        <Button
          options={{ skin: "primary", size: "md", type: "filled" }}
          onClick={() => window.location.reload()}
        >
          Volver a intentarlo
        </Button>
      </Center>
    </>
  );
};

const state = ({ quizStore }) => {
  const { data: newAnswersQuiz } = quizStore.newAnswersQuiz;
  return {
    newAnswersQuiz,
  };
};

export default connect(state)(Component);
